import { api, getApiErrorMessage } from './api'

const CUSTOMER_MANAGEMENT_CUSTOMERS_PATH = '/customer-management/customers'

function unwrapApiData(res) {
  const body = res?.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

export function customerRefIdFromManagedCustomer(customer) {
  for (const raw of [customer?.id, customer?.customerRefId, customer?.refId]) {
    const id = Number(raw)
    if (Number.isFinite(id) && id > 0) return id
  }
  return null
}

export function normalizeManagedCustomerItems(payload) {
  const data = unwrapApiData(payload)
  const items = Array.isArray(data?.items) ? data.items : Array.isArray(data) ? data : []
  return items
    .map((item) => {
      const id = customerRefIdFromManagedCustomer(item)
      return id ? { ...item, id, customerRefId: item?.customerRefId ?? id } : null
    })
    .filter(Boolean)
}

function isApiPathNotFound(error) {
  const status = error?.response?.status
  const data = error?.response?.data
  const code = data?.code != null ? String(data.code) : ''
  const message = data?.message != null ? String(data.message) : ''
  return status === 404 && code === 'NOT_FOUND' && message.includes('API 경로')
}

function sameOriginAbsolutePath(path) {
  if (typeof window === 'undefined' || !window.location?.origin) return null
  return `${window.location.origin}${path}`
}

function unique(values) {
  const seen = new Set()
  return values.filter((value) => {
    if (!value || seen.has(value)) return false
    seen.add(value)
    return true
  })
}

function customerSearchCandidateUrls() {
  const version = String(process.env.REACT_APP_API_VERSION || 'v1').replace(/^\/+|\/+$/g, '') || 'v1'
  return unique([
    CUSTOMER_MANAGEMENT_CUSTOMERS_PATH,
    sameOriginAbsolutePath(`/${version}${CUSTOMER_MANAGEMENT_CUSTOMERS_PATH}`),
    sameOriginAbsolutePath(`/api/${version}${CUSTOMER_MANAGEMENT_CUSTOMERS_PATH}`),
  ])
}

export async function fetchManagedCustomersForPicker({ q = '', page = 0, size = 20 } = {}) {
  const query = String(q || '').trim()
  const params = { page, size }
  if (query) params.q = query

  let lastError = null
  for (const url of customerSearchCandidateUrls()) {
    try {
      return await api.get(url, { params, __silent: true })
    } catch (error) {
      lastError = error
      if (!isApiPathNotFound(error)) throw error
    }
  }
  throw lastError
}

export function managedCustomerSearchErrorMessage(error) {
  if (isApiPathNotFound(error)) {
    const path = error?.response?.data?.path ? String(error.response.data.path) : ''
    return path
      ? `고객 검색 API 경로를 찾지 못했습니다. 호출 경로: ${path}`
      : '고객 검색 API 경로를 찾지 못했습니다.'
  }
  return getApiErrorMessage(error, '고객 목록을 불러오지 못했습니다.')
}
